import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';

export const getSignerAction = ({
	showSignButton,
	onSignClick,
	signButtonLabel,
	signDisabled,
	signDisabledMessage,
	showWitnessButton,
	onWitnessClick,
	witnessButtonLabel,
	showResendButton,
	onResendClick,
	resendButtonLabel,
	resendDisabled,
}: {
	showSignButton?: boolean;
	onSignClick?: () => void;
	signButtonLabel: string;
	signDisabled?: boolean;
	signDisabledMessage?: string;
	showWitnessButton?: boolean;
	onWitnessClick?: () => void;
	witnessButtonLabel?: string;
	showResendButton?: boolean;
	onResendClick?: () => void;
	resendButtonLabel?: string;
	resendDisabled?: boolean;
}) => {
	if (showSignButton && onSignClick) {
		return {
			label: signButtonLabel,
			onClick: onSignClick,
			disabled: !!signDisabled,
			disabledReason: signDisabledMessage,
			testId: TEST_ELEMENT_IDS.DOCUMENT_SIGNER_SIGN_BUTTON,
		};
	}
	if (showWitnessButton && onWitnessClick && witnessButtonLabel) {
		return {
			label: witnessButtonLabel,
			onClick: onWitnessClick,
		};
	}
	if (showResendButton && onResendClick && resendButtonLabel) {
		return {
			label: resendButtonLabel,
			onClick: onResendClick,
			disabled: !!resendDisabled,
		};
	}
	return undefined;
};
